module.exports = __webpack_public_path__ + "static/img/ranking3.899fa3f.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/ranking3.png
// module id = r8ZD
// module chunks = 1